// @flow

import * as React from 'react';
import Button from '@material-ui/core/Button';
import {
  requestAnimationTimeout,
  cancelAnimationTimeout,
} from '../utils/animation-timeout.js';
import { BubbleLoadingAnim } from '../controls/bubble.js';
import { useTheme } from '../theme';

type Props = {|
  disabled?: boolean,
  loading: boolean,
  children: React.Node,
  // make required
  onClick?: () => void,
  onKeyUp?: (event: SyntheticKeyboardEvent<>) => void,
  // remove in favour of onClick
  type?: string,
  delay?: number,
  color?: string,
  variant?: 'outlined' | 'contained',
  size?: 'small' | 'medium' | 'large',
  className?: string,
  css?: { [string]: mixed, ... } | $ReadOnlyArray<{ [string]: mixed, ... }>,
|};

export const LoadingButton = (props: Props): React.Node => {
  const { loading, delay = 0 } = props;
  const { colors } = useTheme();
  const [fakeLoading, setFakeLoading] = React.useState(loading);

  React.useEffect(() => {
    let handle = null;
    if (loading) {
      // delay loading state appearing to prevent blinking with fast response
      handle = requestAnimationTimeout(150, () => setFakeLoading(true));
    } else {
      handle = requestAnimationTimeout(delay, () => setFakeLoading(false));
    }
    return () => {
      cancelAnimationTimeout(handle);
    };
  }, [loading, delay]);

  return (
    <Button
      disabled={props.disabled == null ? loading : props.disabled}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
      onKeyUp={props.onKeyUp}
      color={props.color == null ? 'primary' : props.color}
      size={props.size == null ? 'large' : props.size}
      type={props.type}
      variant={props.variant}
      className={props.className}
    >
      {fakeLoading ? (
        <BubbleLoadingAnim
          css={{
            top: '-2.5em',
            margin: '5.5px auto 5.5px auto',
            color:
              props.variant === 'outlined' ? colors.primaryMain : colors.white,
          }}
        />
      ) : (
        props.children
      )}
    </Button>
  );
};
